import { Form } from 'react-bootstrap';
import style from './style.module.scss';

export default function SwitchCheckbox(props) {

  const { label, checked, onChange } = props;
  return (
    <label className={style.switch}>
      <div className={style.check}>
        <Form.Check
          {...props}
          type="switch"
          onChange={onChange}
          checked={checked}
          label=""
        />
      </div>
      <div className={style.label}>
        {label}
      </div>
    </label>
  )
}